module.exports = __webpack_public_path__ + "img/contact-banner.a1b1facb.webp";